// Generic stages are seeded with hardcoded English names; Applied is priority 0, the other is Hired
const getStageName = (stage, t) =>
  stage.isGeneric ? t(stage.priority === 0 ? 'stageAppliedName' : 'stageHiredName') : stage.name;

export default getStageName;
